import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[50] | typeof colors.primary.white;
};

const Plus = ({ color = colors.red[50] }: Props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Navigation &#38; Actions/plus">
        <path
          id="Vector"
          d="M12.9173 8.00004H3.08398M8.00065 3.08337V12.9167"
          stroke={color}
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
export default Plus;
